module.exports = __webpack_public_path__ + "assets/retina_AngleTrisection54Detailed.8cef2335b9545da97198a4ace4c2117c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_AngleTrisection54Detailed.png
// module id = 622
// module chunks = 0